<template>
  <div class="container">
    <div class="title_container">
      <span class="title_text">{{$t('common.orderNo')}}:<span class="content_text">{{incoOrderNo}}</span></span>
      <span class="title_text">{{$t('common.boxNo')}}:<span class="content_text">{{boxNo}}</span></span>
      <span class="title_text">{{$t('common.productName')}}:<span class="content_text">{{productName}}</span></span>
      <span class="title_text">{{$t('common.lotNo')}}:<span class="content_text">{{lotNo}}</span></span>
      <span class="title_text">{{$t('common.count')}}:<span class="content_text">{{count}}</span></span>
      <span class="title_text">{{$t('common.status')}}:<span class="content_text">{{storeBoxStatusVal(status)}}</span></span>
      <span class="title_text" v-if="storePosition">{{$t('common.storePosition')}}:<span class="content_text">{{storePosition}}</span></span>
      <span class="title_text">binLevel:<span class="content_text">{{binLevelVal(binLevel)}}</span></span>
      <span class="title_text">{{$t('common.createTime')}}:<span class="content_text">{{formatDate(createAt)}}</span></span>
    </div>
    <div class="separator"></div>
    <div class="target-container">
      <el-table
        ref="table"
        height="100%"
        border
        :data="displayData"
        :cell-style="{textAlign: 'center', padding: '8px 0', fontSize: '12px'}"
        :header-cell-style="{textAlign: 'center', padding: '5px 0', fontSize: '12px', color: '#303133', fontFamily: 'SimHei'}"
        header-cell-class-name="headerCellName">
        <el-table-column prop="trackingNo" :label="$t('common.caseNo')"/>
        <el-table-column prop="count" :label="$t('common.count')"/>
        <el-table-column prop="lotNo" :label="$t('common.lotNo')"/>
      </el-table>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import {
  productsDetailById,
} from '@/api/prodStorage';
import { storeBoxStatus } from '@/utils/defines';
const FAIL_BIN = 8;

export default {
  name: 'ProductStorageDetail',
  data() {
    const storeBoxStatusObj = {};
    let orderOprTypeItem;
    for (const key in storeBoxStatus) {
      if (Object.prototype.hasOwnProperty.call(storeBoxStatus, key)) {
        orderOprTypeItem = storeBoxStatus[key];
        storeBoxStatusObj[orderOprTypeItem.val] = orderOprTypeItem.explain;
      }
    }
    return {
      incoOrderNo: undefined,
      boxNo: undefined,
      productName: undefined,
      lotNo: undefined,
      count: undefined,
      status: undefined,
      storePosition: undefined,
      binLevel: undefined,
      createAt: undefined,
      listData: [],
      storeBoxStatusObj,
    };
  },
  mounted() {
    this.id = this.$route.params && this.$route.params.id;
    this.productsDetailById();
  },
  computed: {
    displayData() {
      return this.listData;
    },
  },
  methods: {
    async productsDetailById() {
      const { id } = this;
      try {
        const res = await productsDetailById({
          id,
        });
        const {
          data,
        } = res;
        const {
          record,
        } = data;
        const {
          incoOrder,
          boxNo,
          lotNo,
          count,
          status,
          storePosition,
          binLevel,
          createAt,
          prodStoreDetails,
          incoOrdersDetail,
        } = record;
        if (incoOrder) {
          this.incoOrderNo = incoOrder && incoOrder.incoOrderNo;
        }
        this.listData = prodStoreDetails || [];
        this.boxNo = boxNo;
        this.lotNo = lotNo;
        this.count = count;
        this.status = status;
        this.createAt = createAt;
        this.storePosition = storePosition;
        this.binLevel = binLevel;
        if (incoOrdersDetail) {
          const {
            product,
            incoOrder,
          } = incoOrdersDetail;
          this.incoOrderNo = incoOrder && incoOrder.incoOrderNo || '';
          if (product) {
            this.productName = `${product.productName} / ${product.chipName}`;
          }
        }
      } catch (e) {
        // do nothing.
      }
    },
    storeBoxStatusVal(val) {
      return this.storeBoxStatusObj[val];
    },
    formatDate(date) {
      if (!date) {
        return '';
      }
      const updateDate = moment.utc(date);
      const isSameYear = updateDate.local().format('YYYY') === moment.utc().local().format('YYYY');
      if (isSameYear) {
        return updateDate.local().format('MM/DD HH:mm');
      }
      return updateDate.local().format('YYYY/MM/DD HH:mm');
    },
    binLevelVal(val) {
      if (val !== FAIL_BIN) {
        return `${val}(合格品)`;
      }
      if (val === FAIL_BIN) {
        return `${FAIL_BIN}(坏品)`;
      }
      return `${val}`;
    },
  },
};
</script>

<style scoped>
  .container {
    height: 100%;
    display: -webkit-flex;
    display: flex;
    flex-direction: column;
  }
  .separator {
    width: 100%;
    height: 1px;
    background: #E5E5E5;
    display: block;
  }
  .title_container {
    padding: 20px 30px;
    box-sizing: border-box;
    display: inline-block;
  }
  .title_text {
    font-size: 14px;
    color: #555555;
    margin-right: 50px;
  }
  .content_text {
    margin-left: 10px;
  }
  .target-container {
    flex: 1;
    display: -webkit-flex;
    display: flex;
    margin: 20px 20px 0;
    height: 100%;
    overflow: auto;
  }
  .link {
    color: #169BD5;
    padding: 0 5px;
  }
  .vertical-separator {
    display: inline-block;
    width: 1px;
    height: 12px;
    margin: 0 13px;
    vertical-align: middle;
    background: #e8e8e8;
  }
</style>
<style>
  .headerCellName {
    background: -webkit-linear-gradient(#F9F9F9, #EEEEEE);
    background: -o-linear-gradient(#F9F9F9, #EEEEEE);
    background: -moz-linear-gradient(#F9F9F9, #EEEEEE);
    background: linear-gradient(#F9F9F9, #EEEEEE);
  }
</style>
